import { createContext, useContext } from 'react';

export interface WhiteLabelSettings {
  id: string;
  organizationId: string;
  logoUrl?: string;
  faviconUrl?: string;
  primaryColor: string;
  secondaryColor: string;
  customDomain?: string;
  emailSenderName?: string;
  emailSenderEmail?: string;
  removeBranding: boolean;
  domainVerified: boolean;
}

export interface WhiteLabelContextValue {
  settings: WhiteLabelSettings | null;
  hasAccess: boolean;
  loading: boolean;
  error: Error | null;
}

export const WhiteLabelContext = createContext<WhiteLabelContextValue | undefined>(undefined);

export function useWhiteLabelContext(): WhiteLabelContextValue {
  const context = useContext(WhiteLabelContext);
  if (context === undefined) {
    throw new Error('useWhiteLabelContext must be used within a WhiteLabelProvider');
  }
  return context;
}
